import { testimonials } from "@/mocks/comic";

export default function Testimonials() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-chat-heart-line"></i>
            用户口碑
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            他们这样说静漫天堂
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            来自漫画收藏爱好者、追更读者与创作者的真实反馈，是静漫天堂不断打磨的动力。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="flex flex-col rounded-2xl border border-background-200/70 bg-background-100 p-6"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: t.score }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/15 text-sm font-medium text-primary-600">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <div className="text-sm font-medium text-foreground-950">
                    {t.name}
                  </div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}